<template>
  <div class="checkout-builder-video-modal py-3 px-6">
    <div class="d-flex justify-content-between align-items-center mb-6">
      <h3>Vídeo</h3>
      <button
        class="btn btn-sm py-3 px-4 btn-circle btn-new-secondary"
        @click="$emit('close')"
      >
        <i class="fa fa-close" />
      </button>
    </div>

    <bp-checkbox-group
      class="mb-5"
      v-model="form.config.display"
      :options="[
        { id: 'mobile', name: 'Versão para celular' },
        { id: 'desktop', name: 'Versão para computador' }
      ]"
    />

    <bp-input
      v-model="form.text"
      required
      id="text"
      class="mb-5"
      label="URL do vídeo"
      placeholder="Ex: https://www.youtube.com/watch?v=rCy8om9vwio"
    />

    <div class="row">
      <div class="col-lg-6">
        <bp-select
          v-model="form.config.ratio"
          required
          id="ratio"
          class="mb-5"
          label="Proporção"
          placeholder="Selecione uma opção"
          :options="ratioOptions"
        />
      </div>
    </div>

    <div class="d-flex flex-column flex-lg-row justify-content-end gap-5">
      <bp-button
        class="order-0 order-lg-1"
        label="Inserir vídeo"
        @click="save"
        :disabled="!isValid"
      />
      <bp-button
        color="neutral"
        variant="filled-1"
        label="Cancelar"
        @click="$emit('close')"
      />
    </div>
  </div>
</template>

<script>
import { formFields } from "@/functions/helpers";
export default {
  props: {
    position: {
      type: String,
      default: ""
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      ...formFields(["text", "config"], {
        ...this.data,
        config: {
          ratio: "16by9",
          display: ["desktop", "mobile"],
          ...this.data.config
        }
      }),
      ratioOptions: [
        { id: "21by9", name: "21:9" },
        { id: "16by9", name: "16:9" },
        { id: "4by3", name: "4:3" },
        { id: "1by1", name: "1:1" }
      ]
    };
  },
  computed: {
    isValid() {
      return this.form.text && this.form.config.ratio;
    }
  },
  methods: {
    save() {
      this.$emit("save", { ...this.data, type: "video", ...this.form });
    }
  }
};
</script>
